module.exports = __webpack_public_path__ + "static/img/h-i-2.88759e4b.png";